module.exports = __webpack_public_path__ + "img/map.6426c70.png";